import * as RadixToast from "@radix-ui/react-toast";
import { format } from "date-fns";
import { createContext, ReactNode, useCallback, useContext, useState } from "react";

import { Toast } from "./Toast";
import { OpenToastParams, ToastItem } from "./type";

const OpenToastContext = createContext<{
  openToast: (params: OpenToastParams) => void;
  hasToast: boolean;
}>({ openToast: () => {}, hasToast: false });

export function useToast() {
  return useContext(OpenToastContext);
}

/**
 * - 横幅は文字数に依存せず350px。
 * - 表示する文字数は２行目まで。(36文字以内)
 * - ※トーストは５秒の表示になるため長文は読まない（読めない）
 * - 操作に対するFBのため、簡潔に返答することが望ましいデス
 */
export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  const openToast = useCallback(({ type = "success", description }: OpenToastParams) => {
    setToasts((prev) => [...prev, { id: format(new Date(), "yyyy/MM/dd-HH:mm:ss"), isOpen: true, type, description }]);
  }, []);

  const closeToast = useCallback((id: string) => {
    // closeアニメーション発火のため、isOpenをfalseにしたあと数百ミリ秒待って配列から削除する
    setToasts((prev) => prev.map((value) => (value.id === id ? { ...value, isOpen: false } : value)));

    setTimeout(() => {
      setToasts((prev) => prev.filter((value) => value.id !== id));
    }, 200);
  }, []);

  return (
    <OpenToastContext.Provider value={{ openToast, hasToast: toasts.length > 0 }}>
      <RadixToast.Provider duration={5000}>
        <RadixToast.Viewport className="z-toast fixed left-1/2 top-0 -translate-x-1/2" />
        {toasts
          .filter((element, index, self) => self.findIndex((e) => e.id === element.id) === index)
          .map((value) => (
            <Toast key={value.id} item={value} onClose={closeToast} />
          ))}
        {children}
      </RadixToast.Provider>
    </OpenToastContext.Provider>
  );
};
